/**
 * In dev, use same-origin paths so Vite's proxy handles /config, /login, /logout, /stream, /api/*.
 * That avoids CORS when Electron loads 127.0.0.1:3000 but env points at localhost:5050.
 */
import {withLicense} from './license';
export function backendRestUrl(path: string): string {
    const rel = path.startsWith('/') ? path.slice(1) : path;
    if (import.meta.env.DEV) {
        return `/${rel}`;
    }
    const base = import.meta.env.VITE_API_URL as string;
    return base.endsWith('/') ? `${base}${rel}` : `${base}/${rel}`;
}

export function streamWebSocketUrl(): string {
    if (import.meta.env.DEV) {
        const wsProto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        return withLicense(`${wsProto}//${window.location.host}/stream`);
    }
    const base = import.meta.env.VITE_API_URL as string;
    return withLicense(base.replace(/^http/, 'ws') + 'stream');
}

export function roomGeneratorUrl(): string {
    if (import.meta.env.DEV) {
        return withLicense('/api/rooms/generate');
    }
    return withLicense(import.meta.env.VITE_ROOM_GENERATOR_API_URL as string);
}
